import axios from "axios";
import { IP } from "../index.js";
/* 广告分类 */
export async function selectCategory() {
  var resp = await axios.post(`${IP}/admin/category/select`, {});
  return resp.data;
}

export async function addCategory(data) {
  var resp = await axios.post(`${IP}/admin/category/add`, {
    ...data,
  });
  return resp.data;
}

export async function updateCategory(data) {
  var resp = await axios.post(`${IP}/admin/category/update`, {
    ...data,
  });
  return resp.data;
}

export async function deleteCategory(id) {
  var resp = await axios.post(`${IP}/admin/category/delete`, { id });
  return resp.data;
}

/* 广告管理 */
export async function selectProduct(cid) {
  var resp = await axios.post(`${IP}/admin/product/select`, { cid });
  return resp.data;
}
/* 新增详情图 */
export async function addDetails(productId, detailsImg) {
  var resp = await axios.post(`${IP}/admin/product/addDetails`, {
    productId,
    detailsImg,
  });
  return resp.data;
}
export async function addProduct(form) {
  var resp = await axios.post(`${IP}/admin/product/add`, { ...form });
  return resp.data;
}

export async function updateProduct(form) {
  var resp = await axios.post(`${IP}/admin/product/update`, { ...form });
  return resp.data;
}

export async function deleteProduct(id) {
  var resp = await axios.post(`${IP}/admin/product/delete`, { id });
  return resp.data;
}

export async function setRealByRecommend({ recommend, id }) {
  var resp = await axios.post(`${IP}/admin/product/setRealByRecommend`, {
    recommend,
    id,
  });
  return resp.data;
}
